import React from 'react';
import ServicesContent from '../components/services/ServicesContent';

const ServicesPage: React.FC = () => {
  return <ServicesContent />;
};

export default ServicesPage;
